import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../ui/Dialog";
import { Button } from "../ui/Button";
import { useNavigate } from "react-router-dom";

function ExitModal() {
  const navigate = useNavigate();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary">Go to route select</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            Are you sure you want to exit without saving?
          </DialogTitle>
          <DialogDescription>
            Make sure to save your changes before exiting!
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-between">
          <DialogClose asChild>
            <Button type="button" variant="secondary">
              Close
            </Button>
          </DialogClose>
          <Button onClick={() => navigate("/route-select")} type="submit">
            Go to route select
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default ExitModal;
